export default __webpack_public_path__ + "static/Metal_Hatchframe-7257d2840edc4c74ca1d6d04d2764c74.png";